import styled from 'styled-components';

import { ReactComponent as BaseCalendar } from 'assets/images/icon-calendar.svg';
import { ReactComponent as BaseOrigin } from 'assets/images/icon-origin.svg';
import { ReactComponent as BasePin } from 'assets/images/icon-pin.svg';
import Button from 'components/Buttons/Button';
import CheckboxComponent from 'components/Checkbox';

export const Container = styled.div`
  padding: 16px;
  background-color: #f9f9f9;
  min-height: 100%;
  @media ${({ theme }) => theme.device.desktop} {
    min-height: min(800px, 90vh);
  }
  @media ${({ theme }) => theme.device.mobile} {
    padding-top: 70px;
  }
`;

export const Title = styled.h1`
  font-size: 24px;
  font-weight: 600;
  letter-spacing: -0.04em;
  line-height: 115%;
`;

interface FieldProps {
  columns?: number;
}

export const TravelKindRowContainer: any = styled.section`
  display: flex;
  justify-content: space-around;
  margin-bottom: 16px;

  @media ${({ theme }) => theme.device.desktop} {
    width: 50%;
  }
`;

TravelKindRowContainer.CheckboxContainer = styled.div`
  display: flex;

  & > span {
    margin-left: 8px;
    color: ${({ theme }) => theme.flightSearch.kindLabel};
  }
`;

TravelKindRowContainer.label = styled.span`
  font-size: 12px;
`;

export const Fields = styled.ol`
  margin-top: 16px;

  @media ${({ theme }) => theme.device.mobile} {
    margin-bottom: 80px;
  }
`;

export const Field = styled.li<FieldProps>`
  display: grid;
  grid-template-columns: ${({ columns }) => `repeat(${columns || 1}, 1fr)`};
  grid-gap: 8px;
  margin: 8px 0;
`;

export const RoundTripIcon = styled.span`
  font-size: 25px;

  & > svg {
    display: block;

    &:last-child {
      margin-top: -15px;
    }
  }
`;

export const SearchButtonContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;

  @media ${({ theme }) => theme.device.mobile} {
    position: fixed;
    left: 0;
    bottom: 0px;
    right: 0;
    width: 100%;
    padding-bottom: 32px;
    box-shadow: 0px -6px 10px rgba(128, 98, 96, 0.16);
    background-color: #fff;
  }

  @media ${({ theme }) => theme.device.desktop} {
    position: absolute;
    left: 0;
    bottom: 0px;
    right: 0;
    width: 100%;
    padding: 0 16px 32px;
    box-shadow: 0px -6px 10px rgba(128, 98, 96, 0.16);
    background-color: #fff;
  }
`;

export const SearchButton = styled(Button)`
  height: auto;
  min-height: 55px;
  font-size: 16px;
  line-height: initial;
  padding: 14px;
  width: 100%;
  margin-top: 16px;
  margin-left: auto;

  @media ${({ theme }) => theme.device.mobile} {
    margin: 16px 16px 0px;
  }
`;

export const Checkbox = styled(CheckboxComponent)`
  margin-top: 24px;
  cursor: pointer;
  & > span {
    border-radius: 4px;
  }

  @media ${({ theme }) => theme.device.desktop} {
    margin-left: auto;
  }
`;

export const BaggageIncluded = styled.h5`
  padding-left: 15px;
  font-size: 12px;
  font-weight: normal;
  font-stretch: normal;
  font-style: normal;
  line-height: 1.33;
  letter-spacing: 0.2px;
  color: ${({ theme }) => theme.flightSearch.baggage};
`;

export const Spacer = styled.div`
  height: 8px;
  width: 100%;
`;

export const IconCalendar = styled(BaseCalendar)`
  width: 18px;
  color: #706967;
  padding: 0 1px;
`;
export const IconOrigin = styled(BaseOrigin)`
  width: 18px;
  color: #706967;
  padding: 0 1px;
`;
export const IconPin = styled(BasePin)`
  width: 16px;
  color: #706967;
  padding: 0 2px;
`;
